import { Box } from "@mui/material";
import React from "react";
import Diagram from "./Diagram";
import LoadForm from "./LoadForm";
import LoadTable from "./LoadTable";
import Summary from "./Summary";
import { useStyles } from "./styles";

const LoadDistribution = () => {
  const styles = useStyles();

  return (
    <Box className={styles.pageRoot}>
      <Box className={styles.sectionCard}>
        <LoadForm />
      </Box>
      <Box className={styles.sectionCard}>
        <Summary />
      </Box>
      <Diagram />
      <LoadTable />
    </Box>
  );
};

export default LoadDistribution;
